import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DICE_QUOTES_CONFIG } from '../../_common/product-config';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { LobStatus, QuoteStatus, StatusCode, NewBusiness, LobCodes } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-quote-bound',
  templateUrl: './quote-bound.component.html',
  styleUrls: ['./quote-bound.component.scss']
})
export class QuoteBoundComponent implements OnInit {
  private headerData: HeaderData;
  private loading: boolean = false;
  private quotemessages = DICE_QUOTES_CONFIG.QuoteMessages;
  private modalMessages = DICE_QUOTES_CONFIG.ModalMessages;
  private quoteResponseData: any;
  private bindModelData: any;
  private lobStatusEnum = LobStatus;
  private quoteStatusEnum = QuoteStatus;
  private lobCodes = LobCodes;

  private bindRatekeys: any = {
    applicationId: '',
    quoteId: '',
    policyEffectiveDate: '',
    waiveTRIA: '',
    certifyWaiveTRIA: ''
  };

  private rateRepsonseData: any;

  private uniquePolicyNumbers: any;

  @ViewChild("issuingPolicyModal", {static: true}) issuingPolicyModal: TemplateRef<any>;

  constructor(private diceService: DiceService, private router: Router, private route: ActivatedRoute, private formatter: NgbDateParserFormatter) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    this.setHeaderData();
    this.fetchPolicyIssuedDetails();
  }

  setHeaderData(details?: any){
    this.headerData.pageTitle = "Policy Issued";

    if(details){
      let pipe = new DatePipe('en-US');

      this.headerData.detailMenu = [{label: "Effective Date", description: pipe.transform(details.policyEffectiveDate, 'MM/dd/yyyy', 'UTC')}];
    }

    this.diceService.header = this.headerData;
  }

  gotoUrl(_url) {
    this.router.navigate([_url], {state: {selectedBusiness: NewBusiness.DICE}});
  }

  /*** Gets Application Key and Quote ID from URL Route / State Params  ***/
  getBindQuoteKeys() {
    //this.QuoteDetailsModelData = this.diceService.diceBindDetailsData;

    this.route.paramMap.subscribe(params => {
      this.bindRatekeys.applicationId = params.get('key').toString();
      this.bindRatekeys.quoteId = params.get("id").toString();

      console.log("bindRatekeys :: ", this.bindRatekeys);
    });
  }

  fetchPolicyIssuedDetails(){
    this.bindModelData = this.diceService.diceBindDetailsData;

    if(this.bindModelData){
      this.loading = true;
      this.diceService.openModal('none', this.issuingPolicyModal, false, 'dark-blue-backdrop', 'static', 'dice-modal', '', true);

      let quoteDetailsSubscription = this.diceService.bindIssueQuoteQueue(this.bindModelData).subscribe(taskId => {
        console.log("Polling TaskID :: ", taskId);

        /* Polling started */
        let pollingIssuanceConfirmationSubscription = this.diceService.queueTask(taskId).subscribe(queueResp => { 
          console.log("finally its successful! " + queueResp);
          this.diceService.closeModal();
          this.loading = false;
          this.quoteResponseData = queueResp;

          this.setHeaderData(this.quoteResponseData);
          this.displayUniquePolicyNumbers();

          this.diceService.removeQuoteStorageData();

          console.log("this.quoteResponseData: ", this.quoteResponseData);
        },
        error=>{
          this.loading = false;
          console.log("opps!! got error after waiting long! " + error);
          this.diceService.closeModal();
          this.router.navigate(["/error"]);
        });

        this.diceService.runningServices.push(pollingIssuanceConfirmationSubscription);

      
      /*  this.diceService.closeModal();
        this.loading = false;
        this.quoteResponseData = response;

        this.setHeaderData(this.quoteResponseData);
        this.displayUniquePolicyNumbers();

        console.log("this.quoteResponseData: ", this.quoteResponseData); */
      },
      error => {
        console.log("Policy Issue Api failed");
        this.loading = false;
        this.diceService.closeModal();
        
        if(error.status == StatusCode.InternalServer) {
          this.gotoUrl('/newbusiness');
        }
      });

      this.diceService.runningServices.push(quoteDetailsSubscription);
    }
    else{
      this.gotoUrl('/newbusiness');
    }
  }

  displayUniquePolicyNumbers () {    
    this.uniquePolicyNumbers = this.quoteResponseData.policyNumber.filter((item, i, ar) => ar.indexOf(item) === i);

    console.log("this.uniquePolicyNumbers :: ", this.uniquePolicyNumbers);
  }

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}
